
import { defineComponent, PropType } from 'vue';
import {
  ActivityIndicator,
  AjaxHelper,
  Matomo,
  MatomoUrl,
  translate,
} from 'CoreHome';
import ManageGroupMembers from './ManageGroupMembers.vue';
import { Group } from './TabManageGroups.vue';

export default defineComponent({
  components: {
    ActivityIndicator,
    ManageGroupMembers,
  },
  data() {
    return {
      newGroupName: '',
      confirmRenameGroupText: '',
      confirmDeleteGroupText: '',
      isRenaming: false,
      isDeleting: false,
    };
  },
  props: {
    group: {
      type: Object as PropType<Group>,
      required: true,
    },
  },
  emits: ['group-renamed', 'group-deleted'],
  mounted() {
    this.onGroupUpdated();
  },
  methods: {
    onGroupUpdated() {
      this.newGroupName = this.group.name;
      MatomoUrl.updateHash({
        ...MatomoUrl.hashParsed.value,
        idGroup: this.group.idGroup,
      });
    },
    confirmRenameGroup() {
      this.confirmRenameGroupText = translate('GroupPermissions_RenameGroupConfirm', this.group.name, this.newGroupName);
      Matomo.helper.modalConfirm('#confirmRenameGroup', {
        yes: () => this.renameGroup(),
      });
    },
    renameGroup() {
      this.isRenaming = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.renameGroup',
      }, {
        idGroup: this.group.idGroup,
        newName: this.newGroupName,
      },
      {
        errorElement: '#ajaxErrorRenameGroup',
      }).then(() => {
        this.$emit('group-renamed', {
          idGroup: this.group.idGroup,
          name: this.newGroupName,
        });
      }).finally(() => {
        this.isRenaming = false;
      });
    },
    confirmDeleteGroup() {
      this.confirmDeleteGroupText = translate('GroupPermissions_DeleteGroupConfirm', this.group.name);
      Matomo.helper.modalConfirm('#confirmDeleteGroup', {
        yes: () => this.deleteGroup(),
      });
    },
    deleteGroup() {
      this.isDeleting = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.deleteGroup',
      }, {
        idGroup: this.group.idGroup,
      },
      {
        errorElement: '#ajaxErrorDeleteGroup',
      }).then(() => {
        this.$emit('group-deleted', this.group);
      }).finally(() => {
        this.isDeleting = false;
      });
    },
  },
  watch: {
    group() {
      this.onGroupUpdated();
    },
  },
});
